import React from 'react';
import { Redirect } from 'react-router-dom';

export default function withAuth(WrappedComponent) {
  return class extends React.Component {
    render() {
      return localStorage.getItem('token') ? (
        <Redirect to="/posts" />
      ) : (
        <WrappedComponent {...this.props} />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/hocs/withAuth2.js